//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SchoolsLoaded } from 'redux/actions';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";
import SchoolEditor from "components/SchoolEditor/SchoolEditor.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class SchoolList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      schools: []
    }
    this.schoolUpdated = this.schoolUpdated.bind(this);
  }

  componentWillMount() {
    this.refreshSchools();
  }

  schoolUpdated() {
    this.refreshSchools();
  }

  refreshSchools() {
    db.getSchools().then(snapshot => {
           
      var schools = [];
      snapshot.forEach((doc) => {

          var obj = doc.data();
          obj.id = doc.id;
          if(!obj.Photos)
            obj.Photos = [];
          schools.push(obj);    
      });

      this.setState({schools: schools});
      this.props.onSchoolsLoaded(schools);
    });
  }

  deleteSchool(school) {
    db.deleteSchool(school.id).then(() => {

      var schools = this.state.schools;
      for(var i = 0; i < schools.length; i++) {
        if(schools[i].id === school.id) {
          schools.splice(i,1);
          break;
        }
      }
      this.setState({schools:schools});
    });
  }

  visibleText(isVisible) {
    if(isVisible)
      return "Yes";
    else
      return "No";
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("app.allthingseq.com/schools");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Schools</h4>
                  <p className={classes.cardCategoryWhite}>
                    
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                        id="tooltip-top-start"
                        title="Add School"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                    >
                      <SchoolEditor onChange={this.schoolUpdated}
                        school={{
                          Name: "",
                          Description: "",
                          LoginPath:"",
                          orgId: this.props.org.id
                        }} />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                      <TableCell style={{padding:"3px"}}>

                      </TableCell>
                      <TableCell>
                        Name
                      </TableCell>
                      <TableCell>
                        City
                      </TableCell>
                      <TableCell>
                        State
                      </TableCell>
                      <TableCell>
                        Status
                      </TableCell>
                      <TableCell>
                        URL Modifier
                      </TableCell>
                      <TableCell style={{display:"none"}}>
                          
                      </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.schools.map(value => (
                    <TableRow key={value.id} className={classes.tableRow}>
                      <TableCell className={classes.tableActions} style={{padding:"3px"}}>
                        <Tooltip
                          id="tooltip-top"
                          title="Edit School"
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                         <SchoolEditor school={value} onChange={this.schoolUpdated}  />
                        </Tooltip>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Name}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.City}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.State}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Status}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.LoginPath}
                      </TableCell>
                      <TableCell className={classes.tableActions} style={{display:"none"}}>
                        <Tooltip id="tooltip-top-start" title="Delete School" placement="top" classes={{ tooltip: classes.tooltip }} >
                          <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this school? This action cannot be undone." confirmed={() => this.deleteSchool(value)} />
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({onSchoolsLoaded: SchoolsLoaded }, dispatch);  
}

SchoolList = connect(mapStateToProps, mapDispatchToProps)(SchoolList);
export default withStyles(styles)(SchoolList);



// WEBPACK FOOTER //
// ./src/views/SchoolList/SchoolList.jsx